import styles from './styles.module.scss';

const SidebarBody = ({ children, isScrollY }) => {
  return (
    <div className={`${styles.sidebarBody} ${isScrollY ? 'custom-scroll' : ''}`}>
      {children}
    </div>
  );
};

export default SidebarBody;
